import { render, staticRenderFns } from "./EditItemModal.vue?vue&type=template&id=890b9f20&scoped=true"
import script from "./EditItemModal.vue?vue&type=script&lang=js"
export * from "./EditItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890b9f20",
  null
  
)

export default component.exports